import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {DeleteFavoriteDoctorRequest} from 'domain/usecases';
import {deleteFavoriteDoctor} from '../services/deleteFavoriteDoctor';

export function useDeleteFavoriteDoctorMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			cdEspecialidade,
			cdSubEspecialidade,
			cdPrestador,
			signal,
		}: DeleteFavoriteDoctorRequest) =>
			deleteFavoriteDoctor({cdEspecialidade, cdSubEspecialidade, cdPrestador, signal}),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_DOCTORS],
				refetchType: 'none',
			});
			queryClient.refetchQueries({
				queryKey: [QUERY_KEYS.HOME],
			});
		},
	});
}
